import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.connectors, (connector) => {
      return (_openBlock(), _createBlock($setup["ConnectorComponent"], {
        key: connector.id,
        connector: connector,
        onClicked: $setup.onClickChild
      }, null, 8, ["connector"]))
    }), 128))
  ]))
}